module.exports = __webpack_public_path__ + "img/move-transparent.65deef46.png";